import React from "react";
import L from "leaflet";
import { MapContainer, Marker, TileLayer, Polyline, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";

// Fix Leaflet default icon paths for Webpack
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

const driverIcon = new L.DivIcon({
  className: "driver-icon",
  html: `<div style="width:22px;height:22px;background:#3D5A45;border:3px solid #F3F4F3;border-radius:50%;box-shadow:0 0 0 4px rgba(61,90,69,0.35);"></div>`,
  iconSize: [22, 22],
  iconAnchor: [11, 11],
});

const homeIcon = new L.DivIcon({
  className: "home-icon",
  html: `<div style="width:16px;height:16px;background:#E8E3D9;border:3px solid #0A0B0A;border-radius:4px;"></div>`,
  iconSize: [16, 16],
  iconAnchor: [8, 8],
});

const storeIcon = new L.DivIcon({
  className: "store-icon",
  html: `<div style="width:16px;height:16px;background:#F5A623;border:3px solid #0A0B0A;border-radius:50%;"></div>`,
  iconSize: [16, 16],
  iconAnchor: [8, 8],
});

export default function LiveMap({ store, delivery, driver, height = 320, testId }) {
  const points = [];
  if (store) points.push([store.lat, store.lng]);
  if (driver && driver.lat && driver.lng) points.push([driver.lat, driver.lng]);
  if (delivery) points.push([delivery.lat, delivery.lng]);
  const center = points[0] || [34.0479, -118.2497];

  const bounds =
    points.length >= 2 ? L.latLngBounds(points.map(([lat, lng]) => L.latLng(lat, lng))) : null;

  return (
    <div
      data-testid={testId}
      className="rounded-2xl overflow-hidden border border-white/10"
      style={{ height }}
    >
      <MapContainer
        center={center}
        zoom={13}
        style={{ height: "100%", width: "100%" }}
        bounds={bounds || undefined}
        boundsOptions={{ padding: [40, 40] }}
        scrollWheelZoom={false}
      >
        <TileLayer
          url="https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OSM</a> &copy; <a href="https://carto.com/attributions">CARTO</a>'
          subdomains="abcd"
        />
        {store && (
          <Marker position={[store.lat, store.lng]} icon={storeIcon}>
            <Popup>{store.name}</Popup>
          </Marker>
        )}
        {delivery && (
          <Marker position={[delivery.lat, delivery.lng]} icon={homeIcon}>
            <Popup>Your address</Popup>
          </Marker>
        )}
        {driver && driver.lat && driver.lng && (
          <Marker position={[driver.lat, driver.lng]} icon={driverIcon}>
            <Popup>Driver</Popup>
          </Marker>
        )}
        {points.length >= 2 && (
          <Polyline
            positions={points}
            pathOptions={{ color: "#3D5A45", weight: 3, dashArray: "6 8" }}
          />
        )}
      </MapContainer>
    </div>
  );
}
